import { LmiContractConfig, QualificationType } from './types';

export const vaLmiContractConfig: LmiContractConfig = {
  title: 'Check if you qualify for income-based savings',
  description:
    'You may qualify for additional savings if your household income falls below a certain limit or if you participate in a qualifying low-to-moderate income (LMI) program.',
  lmiProofCategory: 'qualifying_programs',

  fields: [
    {
      name: 'county',
      type: 'select',
      label: 'County',
      required: true,
      placeholder: 'Select your county',
    },
    {
      name: 'householdOccupancy',
      type: 'select',
      label: 'Household occupancy',
      required: true,
      placeholder: 'Select an option',
    },
    {
      name: 'qualifyingProgram',
      type: 'multiselect',
      label: 'Select qualifying programs (if applicable)',
      required: false,
    },
    {
      name: 'incomeAttestation',
      type: 'checkbox',
      label: 'Please review and check the statement below to continue.',
      required: true,
      header: 'Household income limit',
      description:
        "Based on your household size, your household's gross annual income limit is {incomeLimit}.",
      interpolations: {
        incomeLimit: {
          source: 'variable',
          variableName: 'incomeLimit',
        },
      },
      enableWhen: {
        allOf: ['county', 'householdOccupancy'],
      },
      options: [
        {
          value: QualificationType.INCOME,
          label:
            'I understand the eligibility requirements for the Program and I have reviewed the income guidelines for participation as an LI customer. I hereby certify that my total household income, from all income-earning members of my household, is no more than 80% of the median income for my locality in which I reside and/or I currently participate in another income-based program that demonstrates my eligibility as a LI customer.',
        },
      ],
    },
  ],

  contractLink: {
    preText: 'I have reviewed my',
    postText: '. By proceeding, I will be submitting my e-signature on the',
  },
};
